import { Component, Input, OnInit } from '@angular/core';
import { TransactionItem, TransactionTypeEnum, OutlineItem } from 'src/app/shared/models/base.models';

@Component({
  selector: 'app-transaction-list-item',
  templateUrl: './transaction-list-item.component.html',
  styleUrls: ['./transaction-list-item.component.css']
})
export class TransactionListItemComponent implements OnInit {
  @Input() transaction: TransactionItem;
  TransactionTypeEnum = TransactionTypeEnum
  constructor() { }

  ngOnInit() {
  }

}
